import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import TierRow from '../TierRow';
import { PromoterOfferTier } from '../../../TierSelection';

interface Props {
  isLoading: boolean;
  items: PromoterOfferTier[];
  onSelect: (item: PromoterOfferTier) => void;
  selectedItems: PromoterOfferTier[];
  lastElementRef?: (node: HTMLLIElement) => void;
}

const TierList = ({
  isLoading,
  items,
  onSelect,
  selectedItems,
  lastElementRef
}: Props) => {
  if (!isLoading && items && items?.length === 0) {
    return (
      <div className="h-[30vh] flex flex-col items-center justify-center mt-6">
        <p className="text-base font-normal mt-4"> No Items Found </p>
      </div>
    );
  }
  return (
    <div className="w-full h-[30vh]">
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <Spinner type={SpinnerType.PRIMARY} />
        </div>
      ) : (
        <>
          <ul className="flex flex-col gap-4 ">
            {items?.map((item) => (
              <TierRow
                key={item.id}
                product={item}
                onSelect={() => onSelect(item)}
                id={item.id}
                isSelected={selectedItems.some(
                  (selectedItem) => selectedItem.id === item.id
                )}
                isDisabled={false}
                ref={lastElementRef}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default TierList;
